import type { IGoal, IGoalGroup } from '../../goals/types/Goal';
import { GoalTaskStatus } from '../../goals/types/Goal';
import type { AccountSummary } from '../../holistic/types/HolisticSummary';

export const getGoalTaskCounts = (goal: IGoal) => {
    const { tasks } = goal;

    const completedTaskCount = tasks.filter(
        (task) => task.status === GoalTaskStatus.COMPLETE,
    ).length;

    const totalTaskCount = tasks.filter((task) =>
        [GoalTaskStatus.IN_PROGRESS, GoalTaskStatus.COMPLETE].includes(
            task.status,
        ),
    ).length;

    return {
        completedTaskCount,
        totalTaskCount,
    };
};

export const getAllHolisticAccountsNotLinkedToGoals = (
    membershipGoals: IGoalGroup[],
    holisticAccounts: AccountSummary[],
) => {
    // grab all the holistic accounts that have already been linked to goals
    const allAccountsLinkedToGoals = (membershipGoals ?? [])
        .map((goalGroup) =>
            goalGroup.goals.map((goal) => goal.accountLinks).flat(),
        )
        .flat()
        .filter((linkedAccount) => linkedAccount !== undefined);

    // use the above data to determine which holistic accounts have not been linked to goals
    return holisticAccounts.filter((holisticAccount) => {
        return !allAccountsLinkedToGoals.find(
            (linkedAccount) =>
                holisticAccount.provider.toUpperCase() ===
                    linkedAccount.provider &&
                holisticAccount.id === linkedAccount.accountId,
        );
    });
};
